<template>
	<svg
		width="8"
		height="14"
		viewBox="0 0 16 2"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="0.314453"
			y="0.490967"
			width="16.3357"
			height="1.01818"
			fill="#3F3844"
		/>
	</svg>
</template>

<script setup>
// Minus/decrement icon component for cart quantity controls
</script>
